import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ForcePasswordChange from "@/components/ForcePasswordChange";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy text-gold">
        <span className="eyebrow">Authenticating…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  // SEC-06: block the portal until an exposed-credential account rotates it.
  if (user.force_password_reset) return <ForcePasswordChange />;
  return children;
}
